import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { getTotem, setAuthToken, setCidade } from '../../api/apiFactory';
import {
  fetchLimparCookie, fetchNomeCidade, fetchSecretariasCartaServicos, fetchServicos, fetchVerificarStatusCidade,
} from '../../api/endpoints';
import {
  definirCidade, desfazerCidade, fetchConfiguracoesCidade, selectCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import { definirSecretaria, desfazerSecretaria, selectSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import {
  Alerta,
  AppBody, AppFragment, Container, Grid, GridCartaServicos, Interno, Titulo,
} from '../../styles/base';
import Carregar from '../../components/Carregar/Carregar';
import FormControl from '../../components/FormControl/FormControl';
import { LinhaForm3 } from '../../components/FormControl/FormControlEstilo';
import Botao from '../../components/Botao/Botao';
import ListaCartaServicos from '../../components/ListaCartaServicos/ListaCartaServicos';
import GridBotao from '../../components/GridBotao/GridBotao';
import { isCorClara } from '../../util/color';

const secretariaDefaultValues = {
  Id: 0,
  Campo: '',
  CorHtml: '',
};

const SelecionarCartaServicos = () => {
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const [listaServicos, setListaServicos] = useState(null);

  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosCidade = useSelector(selectCidade);
  const dadosModal = useSelector(selectModal);
  const dadosLogin = useSelector(selectLogin);

  const dispatch = useDispatch();
  const history = useHistory();

  const [palavraChave, setPalavraChave] = useState('');
  const [secretaria, setSecretaria] = useState(secretariaDefaultValues);

  /*
  Versão antiga: Antes eu tinha a tela de listagem com todas as cartas, independente da secretaria. Agora eu tenho uma tela prévia inicial que lista as secretarias,
  e a depender de qual secretaria selecionada, aí sim eu exibo a tela de listagem já filtrando por aquela secretaria específica. O ponto que agora nessa tela de listagem,
  eu preciso exibir no título, qual é a secretaria atualmente selecionada, deixando o título da seguinte forma: "Carta de Serviços - Nome da Secretaria".
  Dito isso, agora eu preciso também, além do Id para enviar via parâmetro para os métodos, do Campo do nome da secretaria.
  Então, ao invés de criar um useState que armazena apenas um inteiro, agora eu criei um useState com um objeto, o qual tem o campo "Id" e "Campo";
  */

  // const [secretaria, setSecretaria] = useState(0);

  /*
  Campo criado somente para exibir a palavra pesquisada ao usuário caso não encontre nenhum resultado com essa palavra. Eu poderia utilizar o próprio campo "palavraChave"
  acima, porém como o react atualiza tudo em tempo real, conforme eu apago ou altero o valor no input, o texto exibido ao usuário também ficaria sendo alterado, mas eu preciso
  que ele fique fixo, justamente pra mostrar ao usuário qual foi a palavra pesquisada.
  */

  const [palavraChavePesquisa, setPalavraChavePesquisa] = useState('');

  const [carregando, setCarregando] = useState(false);

  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    if (id) {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  const escolherCidadeCookie = async (Id, Campo) => {
    setListaSecretarias(null);
    setCidade({ Id, Campo });
    dispatch(definirCidade({
      idCidade: Id,
      nomeCidade: Campo,
    }));
    await fetchLimparCookie();
    await dispatch(fetchConfiguracoesCidade());
    await fetchSecretariasCartaServicos().then(setListaSecretarias);
  };

  useEffect(() => {
    if (cookieId) {
      dispatch(desfazerConexao());
      fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
    }

    if (dadosCidade.data) {
      fetchSecretariasCartaServicos().then(setListaSecretarias);
    }

    if (dadosCidade && dadosCidade.configuracoes && !dadosCidade.configuracoes.CartaDeServicos) {
      history.push('/');
    }

    checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
  }, []);

  /*
  Entenda a Lógica: Eu estava tendo um problema referente à navegação entre a página que lista as secretarias, a página da listagem das cartas, e a página de detalhes:
  O problema que ocorria era que quando eu estava na página de detalhes e clicava para "retornar para carta de serviços", o certo seria retornar para a listagem com as
  cartas de serviços pertencentes à secretaria que até então estava selecionada. Porém, o que estava acontecendo é que ao clicar para retornar, na tela de detalhes,
  eu estava sendo redirecionado para a tela inicial de carta de serviços, onde eu teria que novamente escolher a secretaria que desejo, para aí sim voltar para a tela de listagem.
  Agora imagina o usuário estando na tela de detalhes, daí ele deseja ver uma outra carta de serviço pertencente à mesma secretaria, dai quando ele clica em voltar, ele é
  direcionado para a listagem geral das secretarias, daí ele teria que toda vez ficar procurando a secretaria que estava e acessar novamente ela. Isso não seria boa prática.
  Dito isso, para corrigir, eu fiz uso do useSelector, para assim que o usuário selecionar a secretaria dele, eu salvaria em memória através do useSelector, a propriedade
  "dadosSecretaria". Com essa propriedade, eu consigo navegar entre páginas e manter o valor da secretaria que foi atribuido, logo com isso eu consigo retornar da tela
  de detalhes de uma carta, para a tela de listagem das cartas pertencentes à mesma secretaria da carta atual (ao invés de retornar errado para a listagem de secretarias).
  Eu utilizarei então "dadosSecretaria" como um "ByPass" até o meu useState criado de nome "secretaria". Então assim que o usuário seleciona a secretaria, eu a salvo em
  "dadosSecretaria" (através do "dispach"), e depois eu pego esse "dadosSecretaria" e alimento o meu useState de "secretaria", conforme código criado abaixo.
  Na tela de listagem de carta de serviços de uma secretaria, quando o usuário clicar para cancelar a secretaria atual, eu preciso então limpar o dispach que foi feito,
  limpando então os dados da secretaria que foram salvos em "dadosSecretarias".
  */

  /*
  No useEffect abaixo, assim que "dadosSecretaria" for alterado, significa que o usuário clicou em alguma secretaria, o que disparou o "dispach" para salvar a secretaria.
  Tendo agora a secretaria salva em um useSelector chamado "dadosSecretaria", eu pegarei esses dados e popularei o meu useState de nome "secretaria". No "else" eu testo se
  não há dados para o useSelector, o que significaria que o usuário clicou para trocar/remover a secretaria atual, o que dispara um "dispach" para limpar os dados, então
  eu preciso também limpar o meu useState de "secretaria", resetando-o para os valores padrões, e também limpo a lista de carta de serviços atual.
  */

  useEffect(() => {
    if (dadosSecretaria && dadosSecretaria.data) {
      setSecretaria({
        ...secretaria,
        Id: dadosSecretaria.data.idSecretaria,
        Campo: dadosSecretaria.data.nomeSecretaria,
        CorHtml: dadosSecretaria.data.corSecretaria,
      });
    } else {
      setPalavraChave('');
      setPalavraChavePesquisa('');

      setSecretaria(secretariaDefaultValues);
      setListaServicos(null);
    }
  }, [dadosSecretaria]);

  /*
  Estou colocando um segundo useEffect só para "secretaria" pois caso eu colosasse o trecho de código abaixo referente à fetchServicos dentro do useEffect acima logo após
  o uso de setSecretaria, o react não respeitaria/esperaria a definição do id da secretaria, portanto o ID continuaria 0, e não ocorreria a requisição dos serviços.
  Dito isso, eu coloco um useEffect próprio para observar o useState "secretaria", assim eu garanto que o react vai respeitar e fazer a requisição dos serviços
  apenas quando notar que "secretaria" foi atualizado (que esse é o papel afinal do useEffect);
  */

  /*
  Se "secretaria" foi alterado, significa que eu atribui a ele os valores advindos do useSelector de "dadosSecretaria", ou seja, significa que o usuário selecionou uma secretaria.
  Logo eu preciso agora então fazer a requisição das cartas de serviço próprias para a secretaria atual selecionada. O "if" dentro do useEffect abaixo é para proteger, pois
  "secretaria" também é alterado quando o usuário "cancela"/troca a secretaria atual, pois esse ato limpa "dadosSecretaria" e consequentemente eu limpo também "secretaria",
  através da linha "setSecretaria(secretariaDefaultValues);" do useEffect acima. Então caso "secretaria" e/ou "secretaria.Id" sejam vazios, não farei a requisição.
  */

  useEffect(() => {
    if (secretaria && secretaria.Id) {
      fetchServicos(secretaria.Id).then(setListaServicos);
    }
  }, [secretaria]);

  const pesquisarServico = (event) => {
    event.preventDefault();
    setCarregando(true);

    setPalavraChavePesquisa(palavraChave);
    fetchServicos(secretaria.Id, palavraChave).then(setListaServicos);

    setCarregando(false);
  };

  // Carta de Serviços Completa
  if (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.CartaDeServicos && dadosCidade.configuracoes.CartaDeServicos.toLowerCase() === 'completa') {
    // Proteção para caso o método que carrega as secretarias não trouxer nenhuma.
    if (!listaSecretarias) {
      return (
        <Carregar />
      );
    }

    /*
      Tela inicial: O usuário precisa selecionar qual secretaria deseja consultar a listagem de carta de serviços, assim como é na ouvidoria, sic e zeladoria.
      OBS: Caso o Id da secretaria seja 0, significa que o usuário ainda não selecionou uma secretaria, e portanto exibimos a tela abaixo com a listagem de secretarias.
      OBS: testar "!secretaria.Id" é a mesma coisa que testar "secretaria.Id === 0"

      OBS: Ainda nessa tela, temos um filtro de "palavras-chave", o qual filtrará por palavra chave todas as cartas de serviço, independente da secretaria.
      OBS: Assim que a palavra-chave for inserida e pesquisada, eu irei redirecionar para a outra tela, onde lista as cartas de serviços encontradas.
      Com a única diferença que eu não irei exibir, na outra tela, o container com a secretaria atualmente selecionada, pois nenhuma de fato foi selecionada, apenas rolou a pesquisa da palavra-chave.
    */

    if ((!secretaria || (secretaria && !secretaria.Id)) && !palavraChavePesquisa) {
      return (
        <AppFragment
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              dispatch(resetarModais());
            }
          }}
          tabIndex="0"
        >
          {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
          {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
          {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
          <AppHeader />
          <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
            <Container totem={getTotem() === 'true'}>
              <Titulo totem={getTotem() === 'true'}>Carta de Serviços</Titulo>

              <Interno>
                <LinhaForm3>
                  <FormControl
                    idCampo="inputPalavraChave"
                    value={palavraChave}
                    label="Palavras-chave:"
                    onChange={({ target }) => setPalavraChave(target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        pesquisarServico(e);
                      }
                    }}
                  />

                  {carregando !== true
                    ? (
                      <Botao
                        label="Pesquisar"
                        type="submit"
                        onClick={pesquisarServico}
                        busca
                      />
                    )
                    : (
                      <Carregar />
                    )}
                </LinhaForm3>

                <Grid style={{ marginTop: 30 }}>
                  {listaSecretarias && listaSecretarias.length > 0 && listaSecretarias.map(({
                    Campo, Id, Icone, CorHtml,
                  }) => (
                    <GridBotao
                      totem={getTotem() === 'true'}
                      onClick={() => dispatch(definirSecretaria({ idSecretaria: Id, nomeSecretaria: Campo, corSecretaria: CorHtml }))}
                      key={Id}
                      label={Campo}
                      title={Campo}
                      img={`https://eouve.com.br/svg_icons/${isCorClara(CorHtml) ? 'dark' : 'light'}/${Icone}.svg`}
                      size={14}
                      imgWidth={50}
                      imgHeight={50}
                      cor={CorHtml}
                      secretaria
                      className="controle-secretaria"
                    />
                  ))}
                </Grid>
              </Interno>
            </Container>
          </AppBody>
        </AppFragment>
      );
    }

    /*
      No início do desenvolvimento, o código abaixo era a tela inicial, onde exibia a listagem completa de cartas de serviços, independete de qual secretaria fosse.
      Nessa tela, tinhamos então um filtro por "Palavras-chave" e "Secretaria".

      Agora, adicionamos uma tela prévia (código acima), a qual será a tela inicial, onde teremos um grid de botões com todas as secretarias (assim como na ouvidoria, sic e zeladoria, onde escolhemos a secretaria antes de criar o protocolo).
      Depois que o usuário selecionar uma secretaria, aí sim irá abrir a tela abaixo, que é a listagem com as cartas de serviços como já conheciamos, porém filtradas pela secretaria escolhida previamente.
      Dito isso, não faz mais sentido então adicionar a opção de filtro por "secretaria" como tinhamos anteriormente através de um drop, logo teremos somente como opção
      a escolha de "palavras-chave", justamente pelo fato do filtro de secretarias já ter sido implicitamente. Então por isso deixarei comentado o filtro por secretarias.

      EXTRA: Na tela inicial das secretarias (código acima), adicionamos agora um filtro por palavra-chave, e caso o usuário faça uma pesquisa, irá redirecionar para essa tela também,
      com a diferença que NÃO terá uma secretaria selecionada, e portanto eu irei ocultar o container colorido que mostra qual a secretaria atualmente selecionada (e que tem o botão de "cancelar" a secretaria atual).
      Portanto enquanto o usuário utilizar o filtro de palavras-chave, sem selecionar uma secretaria específica (clicando no botão da secretaria), eu irei ficar na tela abaixo filtrando as cartas de serviço.
    */

    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        <AppHeader />
        <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
          <Container totem={getTotem() === 'true'}>
            <Titulo totem={getTotem() === 'true'}>Carta de Serviços</Titulo>

            <Interno>
              {(secretaria && secretaria.Id > 0) && (
                <FormControl
                  type="secretariaServicos"
                  corFundo={secretaria.CorHtml}
                  secretaria={secretaria.Campo}
                  onClick={() => {
                    dispatch(desfazerSecretaria());
                  }}
                />
              )}

              <LinhaForm3>
                <FormControl
                  idCampo="inputPalavraChave"
                  value={palavraChave}
                  label="Palavras-chave:"
                  onChange={({ target }) => setPalavraChave(target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      pesquisarServico(e);
                    }
                  }}
                />

                {/* Filtro por secretarias que não é mais necessário pois criei uma tela prévia onde o usuário selecionará qual secretaria ele quer acessar as cartas de serviço  */}
                {/* {(listaSecretarias && listaSecretarias.length > 0) && (
                  <FormControl
                    idCampo="selectSecretaria"
                    value={secretaria.Id}
                    label="Secretaria:"
                    options={listaSecretarias}
                    onChange={({ target }) => setSecretaria({ ...secretaria, Campo: target.options[target.selectedIndex].text, Id: target.value })}
                    type="select"
                  />
                )} */}

                {carregando !== true
                  ? (
                    <Botao
                      label="Pesquisar"
                      type="submit"
                      onClick={pesquisarServico}
                      busca
                    />
                  )
                  : (
                    <Carregar />
                  )}
              </LinhaForm3>

              {(listaServicos && listaServicos.length > 0) ? (
                <GridCartaServicos>
                  {listaServicos.map((item) => (
                    <Link style={{ textDecoration: 'none', color: 'black' }} to={`/cartadeservicos/${item.Id}`}>
                      <ListaCartaServicos
                        Cor={item.Cor}
                        secretaria={item.Secretaria}
                        servico={item.Servico}
                      />
                    </Link>
                  ))}
                </GridCartaServicos>
              ) : (
                <p>
                  <Alerta style={{ marginTop: 30 }}>
                    {
                      (palavraChavePesquisa ? (
                        <>
                          Nenhum serviço com a palavra-chave
                          {' '}
                          <b>{palavraChavePesquisa}</b>
                          {' '}
                          foi encontrado.
                        </>
                      ) : (
                        <>Não há nenhuma informação cadastrada.</>
                      ))
                    }
                  </Alerta>
                </p>
              )}
            </Interno>
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  // Carta de Serviços Simplificada
  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <AppHeader />
      <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
        <Container totem={getTotem() === 'true'}>
          <Titulo totem={getTotem() === 'true'}>Carta de Serviços</Titulo>

          <Interno>
            <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes && dadosCidade.configuracoes.CartaDeServicos }} />
          </Interno>
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default SelecionarCartaServicos;
